/** @file An entity-relative drawable point rounded once, then made absolute (design 21.4 rules 1-2). */
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';
import type { View } from '@zilo/pose3d-render-core/camera/viewOf';
import { entityPointOf } from '@zilo/pose3d-render-core/place/entityPointOf';
import { snapRelOf } from '@zilo/pose3d-render-core/place/snapRelOf';

/** `round(entityPos) + round(rel)` when the profile snaps, `entityPos + rel` otherwise. */
export function absolutePointOf(rel: Vec3, entityPos: Vec3, view: View): Vec3 {
  return entityPointOf(snapRelOf(rel, view), entityPos, view);
}
